import React from 'react';
import { Grid, Box, Typography, FormControlLabel, Switch } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

function InboundPakForm({
  automation,
  onAutomationChange,
  classes
}) {
  const { t } = useTranslation();
  const isDisabled = !automation.outboundPak;

  return (
    <>
      <FormControlLabel
        classes={{ root: classes.switchContainer, label: classes.switchLabel }}
        labelPlacement="start"
        control={
          <Switch
            checked={automation.inboundPak}
            onChange={(e) => onAutomationChange({ ...automation, inboundPak: e.target.checked })}
            disabled={isDisabled}
          />
        }
        label={t('processTypes.inboundPak_form.labels.inbound_pak')}
      />

      {!automation.outboundPak && (
        <Typography variant="caption" style={{ marginLeft: 8, color: '#F69B12' }}>
          {t('processTypes.inboundPak_form.warning')}
        </Typography>
      )}

      {automation.inboundPak && !isDisabled && (
        <Box className={classes.previewContainer}>
          <Typography variant="caption" color="textSecondary" component="p">
            {t('processTypes.inboundPak_form.paragraph1')}
          </Typography>
        </Box>
      )}
    </>
  );
}

export default InboundPakForm;
